module.exports = __webpack_public_path__ + "static/img/celoscope-27.b6cff66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-27.jpg
// module id = R61u
// module chunks = 51